import { ServerPlusOutlineIcon } from './ServerPlusOutlineIcon';

/**
 * author: Kadensvw
 * id 9F0E48B8-D7E7-40D9-A985-76FBDC113F4D
 * name server-plus-outline
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/server-plus-outline.svg
 * tags
 */
export const ServerAddOutlineIcon = ServerPlusOutlineIcon;
export default ServerAddOutlineIcon